import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useSearchParams } from "react-router-dom";

import { MultiLanguageUrl } from "../constants/multiLanguage.constant";

const PlanVerify = () => {
  const { t, i18n } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const plan_name = searchParams.get("plan_name");
    const status = searchParams.get("status");

    if (!plan_name && !status)
      navigate(`/${MultiLanguageUrl[i18n.language] || "en-US"}/control-panel`, {
        replace: true
      });
  }, []);

  // 10 second progressbar
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress >= 100) {
          clearInterval(timer);
          navigate(
            `/${MultiLanguageUrl[i18n.language] || "en-US"}/control-panel${
              window.location.search
            }`,
            { replace: true }
          );

          return 100;
        }
        return prevProgress + 10; // Increase progress by 10% every second
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  return (
    <div className="tw-w-screen tw-h-screen tw-px-[84px] tw-pt-[84px] tw-pb-[92px] tw-bg-white tw-flex-col tw-justify-center tw-items-center tw-gap-6 tw-inline-flex">
      <div className="tw-justify-start tw-items-start tw-gap-4 tw-inline-flex">
        <div className="tw-w-[51px] tw-h-[41px] tw-relative">
          <svg
            width="52"
            height="41"
            viewBox="0 0 52 41"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M2.844 32.271L4.844 35.731C4.97678 35.9605 5.19527 36.1279 5.45143 36.1963C5.70758 36.2648 5.98044 36.2287 6.21 36.096L7.606 35.29C8.186 35.747 8.827 36.122 9.501 36.402V38C9.501 38.2652 9.60635 38.5196 9.79389 38.7071C9.98143 38.8946 10.2358 39 10.501 39H14.501C14.7662 39 15.0206 38.8946 15.2081 38.7071C15.3956 38.5196 15.501 38.2652 15.501 38V36.402C16.1803 36.1192 16.8178 35.7451 17.396 35.29L18.792 36.096C19.269 36.371 19.883 36.206 20.158 35.731L22.158 32.271C22.2896 32.0412 22.3251 31.7687 22.2567 31.5129C22.1884 31.257 22.0217 31.0385 21.793 30.905L20.421 30.112C20.5282 29.3745 20.5275 28.6253 20.419 27.888L21.791 27.095C22.267 26.82 22.432 26.205 22.156 25.729L20.156 22.269C20.0232 22.0395 19.8047 21.8721 19.5486 21.8037C19.2924 21.7352 19.0196 21.7713 18.79 21.904L17.394 22.71C16.8165 22.2544 16.1793 21.8802 15.5 21.598V20C15.5 19.7348 15.3946 19.4804 15.2071 19.2929C15.0196 19.1054 14.7652 19 14.5 19H10.5C10.2348 19 9.98043 19.1054 9.79289 19.2929C9.60535 19.4804 9.5 19.7348 9.5 20V21.598C8.82072 21.8808 8.18318 22.2549 7.605 22.71L6.21 21.904C6.09637 21.8382 5.97087 21.7954 5.84069 21.7781C5.7105 21.7608 5.57819 21.7694 5.45132 21.8033C5.32445 21.8372 5.2055 21.8958 5.10129 21.9757C4.99708 22.0556 4.90965 22.1553 4.844 22.269L2.844 25.729C2.71239 25.9588 2.6769 26.2313 2.74526 26.4871C2.81362 26.743 2.9803 26.9615 3.209 27.095L4.581 27.888C4.47313 28.6254 4.47313 29.3746 4.581 30.112L3.209 30.905C2.733 31.18 2.568 31.795 2.844 32.271ZM12.5 25C14.706 25 16.5 26.794 16.5 29C16.5 31.206 14.706 33 12.5 33C10.294 33 8.5 31.206 8.5 29C8.5 26.794 10.294 25 12.5 25Z"
              fill="#E5E7EB"
            />
            <path
              d="M29.844 32.271L31.844 35.731C31.9768 35.9605 32.1953 36.1279 32.4514 36.1963C32.7076 36.2648 32.9804 36.2287 33.21 36.096L34.606 35.29C35.186 35.747 35.827 36.122 36.501 36.402V38C36.501 38.2652 36.6064 38.5196 36.7939 38.7071C36.9814 38.8946 37.2358 39 37.501 39H41.501C41.7662 39 42.0206 38.8946 42.2081 38.7071C42.3956 38.5196 42.501 38.2652 42.501 38V36.402C43.1803 36.1192 43.8178 35.7451 44.396 35.29L45.792 36.096C46.269 36.371 46.883 36.206 47.158 35.731L49.158 32.271C49.2896 32.0412 49.3251 31.7687 49.2567 31.5129C49.1884 31.257 49.0217 31.0385 48.793 30.905L47.421 30.112C47.5282 29.3745 47.5275 28.6253 47.419 27.888L48.791 27.095C49.267 26.82 49.432 26.205 49.156 25.729L47.156 22.269C47.0232 22.0395 46.8047 21.8721 46.5486 21.8037C46.2924 21.7352 46.0196 21.7713 45.79 21.904L44.394 22.71C43.8165 22.2544 43.1793 21.8802 42.5 21.598V20C42.5 19.7348 42.3946 19.4804 42.2071 19.2929C42.0196 19.1054 41.7652 19 41.5 19H37.5C37.2348 19 36.9804 19.1054 36.7929 19.2929C36.6054 19.4804 36.5 19.7348 36.5 20V21.598C35.8207 21.8808 35.1832 22.2549 34.605 22.71L33.21 21.904C33.0964 21.8382 32.9709 21.7954 32.8407 21.7781C32.7105 21.7608 32.5782 21.7694 32.4513 21.8033C32.3244 21.8372 32.2055 21.8958 32.1013 21.9757C31.9971 22.0556 31.9096 22.1553 31.844 22.269L29.844 25.729C29.7124 25.9588 29.6769 26.2313 29.7453 26.4871C29.8136 26.743 29.9803 26.9615 30.209 27.095L31.581 27.888C31.4731 28.6254 31.4731 29.3746 31.581 30.112L30.209 30.905C29.733 31.18 29.568 31.795 29.844 32.271ZM39.5 25C41.706 25 43.5 26.794 43.5 29C43.5 31.206 41.706 33 39.5 33C37.294 33 35.5 31.206 35.5 29C35.5 26.794 37.294 25 39.5 25Z"
              fill="#D1D5DB"
            />
            <path
              d="M15.844 15.271L17.844 18.731C17.9768 18.9605 18.1953 19.1279 18.4514 19.1963C18.7076 19.2648 18.9804 19.2287 19.21 19.096L20.606 18.29C21.186 18.747 21.827 19.122 22.501 19.402V21C22.501 21.2652 22.6064 21.5196 22.7939 21.7071C22.9814 21.8946 23.2358 22 23.501 22H27.501C27.7662 22 28.0206 21.8946 28.2081 21.7071C28.3956 21.5196 28.501 21.2652 28.501 21V19.402C29.1803 19.1192 29.8178 18.7451 30.396 18.29L31.792 19.096C32.269 19.371 32.883 19.206 33.158 18.731L35.158 15.271C35.2896 15.0412 35.3251 14.7687 35.2567 14.5129C35.1884 14.257 35.0217 14.0385 34.793 13.905L33.421 13.112C33.5282 12.3745 33.5275 11.6253 33.419 10.888L34.791 10.095C35.267 9.82 35.432 9.205 35.156 8.729L33.156 5.269C33.0232 5.0395 32.8047 4.87212 32.5486 4.80367C32.2924 4.73523 32.0196 4.77131 31.79 4.904L30.394 5.71C29.8165 5.25438 29.1793 4.88022 28.5 4.598V3C28.5 2.73478 28.3946 2.48043 28.2071 2.29289C28.0196 2.10536 27.7652 2 27.5 2H23.5C23.2348 2 22.9804 2.10536 22.7929 2.29289C22.6054 2.48043 22.5 2.73478 22.5 3V4.598C21.8207 4.88081 21.1832 5.25492 20.605 5.71L19.21 4.904C19.0964 4.83817 18.9709 4.79539 18.8407 4.7781C18.7105 4.76082 18.5782 4.76937 18.4513 4.80327C18.3244 4.83717 18.2055 4.89576 18.1013 4.97567C17.9971 5.05559 17.9096 5.15526 17.844 5.269L15.844 8.729C15.7124 8.9588 15.6769 9.2313 15.7453 9.48715C15.8136 9.74299 15.9803 9.96147 16.209 10.095L17.581 10.888C17.4731 11.6254 17.4731 12.3746 17.581 13.112L16.209 13.905C15.733 14.18 15.568 14.795 15.844 15.271ZM25.5 8C27.706 8 29.5 9.794 29.5 12C29.5 14.206 27.706 16 25.5 16C23.294 16 21.5 14.206 21.5 12C21.5 9.794 23.294 8 25.5 8Z"
              fill="#9CA3AF"
            />
          </svg>
        </div>
      </div>

      <div className="tw-w-[280px]">
        <div className="tw-bg-gray-200 tw-h-3 tw-rounded-full">
          <div
            role="progressbar"
            className="tw-h-3 tw-rounded-full tw-bg-blue-500 tw-transition-all tw-ease-in"
            aria-valuemin={0}
            aria-valuemax={100}
            style={{
              width: `${progress}%`
            }}
          />
        </div>
      </div>

      <div className="tw-text-gray-700 tw-text-base tw-font-normal tw-font-['Lexend'] tw-leading-normal">
        {t("General/key8")}
      </div>
    </div>
  );
};

export default PlanVerify;
